import React from "react";
import { BrowserRouter as Router } from "react-router-dom";

const publicURL = process.env.PUBLIC_URL;

export function RootRouter({ children }: { children: React.ReactNode }) {
  // React Router v7 delivers location updates inside startTransition by
  // default. Query state round-trips through the URL into controlled inputs,
  // and deferred delivery lets stale renders commit mid-typing and revert
  // input DOM values — dropping typed characters.
  return (
    <Router basename={publicURL} useTransitions={false}>
      {children}
    </Router>
  );
}
